export type ReserveApiEndpoints = {
  GET_RESERVES: string;
  UPDATE_RESERVE: string;
  CREATE_RESERVE: string;
  DELETE_RESERVE: string;
};

export const RESERVE_API_ENDPOINTS: ReserveApiEndpoints = {
  GET_RESERVES: "/api/Reserve/getReservesByProjectId/{projectId}",
  UPDATE_RESERVE: "/api/Reserve/{reserveId}",
  CREATE_RESERVE: "/api/Reserve",
  DELETE_RESERVE: "/api/Reserve/{reserveId}",
};
